import React, { useEffect, useRef } from 'react';
import Button from '../ui/button';

const Hero = () => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (window.TradingView && chartRef.current) {
            new window.TradingView.widget({
                "container_id": chartRef.current.id,
                "width": "100%",
                "height": "100%",
                "symbol": "BINANCE:BTCUSDT",
                "interval": "60",
                "timezone": "Etc/UTC",
                "theme": "dark",
                "style": "1",
                "locale": "en",
                "toolbar_bg": "#111111",
                "enable_publishing": false,
                "allow_symbol_change": true,
                "details": false,
                "studies": ["RSI@tv-basicstudies"],
                "show_popup_button": true,
                "popup_width": "1000",
                "popup_height": "650",
                "no_logo": true
            });
        }
    }, []);

    return (
        <section className="hero">
            <video autoPlay loop muted playsInline className="hero-video-bg">
                <source src="/videos/trading.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            
            <div className="hero-overlay-content">
                <div className="container hero-content">
                    <div className="hero-text fade-in">
                        <h1>
                            The <span>Speed</span> and <span>Precision</span> your Crypto Trading Deserves.
                        </h1>
                        <p>
                            Execute trades instantly on Solana with minimal latency. Access advanced features like MEV protection and a decentralized order book powered by **Kinetix-Engine**.
                        </p>
                        <div className="hero-buttons">
                            <Button variant="primary" className="pulse">Start Trading Now</Button>
                            <Button variant="outline">View Documentation</Button>
                        </div>
                    </div>

                    <div className="hero-image slide-in-right">
                        <div className="trading-preview">
                            <div className="trading-header">
                                <div className="trading-pair">
                                    <i className="fab fa-btc fa-2x"></i>
                                    <div>
                                        <strong>BTC/USD</strong>
                                        <p>Perpetual Futures</p>
                                    </div>
                                </div>
                                <div className="price-info">
                                    <div className="current-price price-update">$68,901.23</div>
                                    <div className="price-change positive">+2.35% (24h)</div>
                                </div>
                            </div>

                            <div className="chart-container">
                                <div className="chart-header">
                                    <div className="timeframes">
                                        <button className="timeframe-btn">1m</button>
                                        <button className="timeframe-btn">5m</button>
                                        <button className="timeframe-btn active">1h</button>
                                        <button className="timeframe-btn">1D</button>
                                    </div>
                                    <div className="chart-actions">
                                        <button className="chart-action-btn"><i className="fas fa-chart-bar"></i></button>
                                        <button className="chart-action-btn"><i className="fas fa-search-plus"></i></button>
                                    </div>
                                </div>
                                <div className="chart-wrapper">
                                    <div ref={chartRef} id="tradingview_chart" className="tradingview-widget-container">
                                        <div className="tradingview-widget-copyright">
                                            <a href="https://www.tradingview.com/" rel="noopener noreferrer" target="_blank">
                                                <span className="blue-text">Track Markets</span> by TradingView
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="trading-actions">
                                <button className="action-btn buy-btn"><i className="fas fa-arrow-up"></i> Buy / Long</button>
                                <button className="action-btn sell-btn"><i className="fas fa-arrow-down"></i> Sell / Short</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;